import { Card } from "@overmap-ai/blocks"
import { NodeViewContent, type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo } from "react"

export const ChatBubbleNode = memo((_props: NodeViewProps) => {
	return (
		<NodeViewWrapper className="ChatBubbleNodeWrapper flex w-full justify-end">
			<Card className="max-w-3/4 mb-2 flex w-max flex-col" size="sm">
				<NodeViewContent />
			</Card>
		</NodeViewWrapper>
	)
})
ChatBubbleNode.displayName = "ChatBubbleNode"
